import { gql } from '@apollo/client'
import { ApiProduct, Customer } from '@vend/types'
import { LineItemUser } from '../models/line-item'

// @todo: Move these types to vend/types, once they are set in stone.
export enum QuoteStatus {
  UNSPECIFIED = 'UNSPECIFIED',
  CREATED = 'CREATED',
  EXPIRED = 'EXPIRED',
  CONVERTED = 'CONVERTED',
  CANCELLED = 'CANCELLED',
  ARCHIVED = 'ARCHIVED',
}

export enum QuoteStatusJAWS {
  // JAWS (jobs and work orders service) returns these statuses
  ARCHIVED = 'QUOTE_STATUS_ARCHIVED',
  CREATED = 'QUOTE_STATUS_CREATED',
}

export type TaxComponent = {
  rateId: string
  totalTax: string
}

export type QuoteProductData = {
  id?: string
  product?: ApiProduct
  productId: string
  price: number
  discount: number
  tax: number
  taxId: string
  quantity: number
  sequence: number
  note: string
  taxComponents: TaxComponent[]
  salesperson: LineItemUser
}

export type QuoteData = {
  status: QuoteStatus | QuoteStatusJAWS
  quoteDate?: string | null
  customerId: string | null
  registerId: string
  userId: string
  retailerId: string
  outletId: string
  totalTax: number | string
  totalPrice: number | string
  expiredAt?: string
  shortCode: string
  loyalty: string | number
  quoteProducts: QuoteProductData[]
  note: string
}

export type QuoteDataWithExtras = QuoteData & {
  id?: string
  customer: {
    id: string
    firstName: string
    lastName: string
    code: string
    companyName: string
  }
  outlet: {
    id: string
  }
}

export type Quote = {
  id: string
  status: QuoteStatus
  quoteDate: string
  customer: Customer
  registerId: string
  userId: string
  retailerId: string
  totalTax: number
  totalPrice: number
  expiredAt: string
  shortCode: string
  deletedAt: string
  quoteProducts: QuoteProduct[]
  note: string
}

export type QuoteProduct = QuoteProductData & {
  quoteId?: string
}

export const createQuoteMutation = gql`
  mutation CreateQuote(
    $quote: QuoteData!
    $shouldSendEmail: Boolean
    $templateId: String
  ) {
    createQuote(
      quote: $quote
      shouldSendEmail: $shouldSendEmail
      templateId: $templateId
    ) {
      id
      status
      quoteDate
      registerId
      customer {
        id
      }
      outlet {
        id
      }
      userId
      quoteProducts {
        productId
      }
      totalTax
      totalPrice
      retailerId
      expiredAt
      shortCode
      deletedAt
      note
    }
  }
`

export const quoteByIdQuery = gql`
  query Quote($quoteId: ID!) {
    quote(id: $quoteId) {
      id
      status
      quoteDate
      customer {
        id
        # used to determine if not an anonymous customer (deleted customer)
        firstName
        lastName
        code
        companyName
      }
      registerId
      userId
      retailerId
      totalTax
      totalPrice
      expiredAt
      shortCode
      deletedAt
      quoteProducts {
        productId
        quantity
        productId
        product {
          name
        }
        price
        discount
        tax
        taxId
        quantity
        sequence
        note
        taxComponents {
          taxRate {
            rate
          }
          totalTax {
            amount
          }
        }
        salesperson {
          id
          displayName
          username
          email
        }
      }
      loyalty
      note
    }
  }
`
